import React from "react";
import { Routes } from "react-router-dom";

import { Route } from "src/shared/components";
import { SponsorRoute } from "src/shared/constants/route";
import { Permission } from "src/shared/contexts";
import NotFound from "src/views/404";

import SponsorHome from "./home";
import SponsorPerksPage from "./perks";
import { SponsorPerksContextProvider } from "./perks/SponsorPerksContext";
import PostEventReport from "./post-event-report";
import SponsorRecruitment from "./recruitment";
import SponsorShippedSwagPage from "./shipped-swag";

export const SponsorRoutes = () => (
  <SponsorPerksContextProvider>
    <Routes>
      <Route path={SponsorRoute.HOME} element={<SponsorHome />} />
      <Route path={SponsorRoute.PERKS} element={<SponsorPerksPage />} />
      <Route
        path={SponsorRoute.POST_EVENT_REPORT}
        element={<PostEventReport />}
        requirePermissions={[Permission.SPONSOR]}
      />
      <Route
        path={SponsorRoute.SHIPPED_SWAG}
        element={<SponsorShippedSwagPage />}
        requirePermissions={[Permission.SPONSOR_SHIPPED_SWAG_ACCESS]}
      />

      <Route
        path={SponsorRoute.RECRUITMENT}
        element={<SponsorRecruitment />}
        requirePermissions={[Permission.SPONSOR_RECRUITMENT_ACCESS]}
      />
      {/* <Route
      path={SponsorRoute.PLATFORM_ONBOARDING}
      element={<SponsorPlatformOnboarding />}
    /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </SponsorPerksContextProvider>
);
